"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const NavigationSearch_1 = __importDefault(require("../Common/Search/NavigationSearch"));
require("./Header.scss");
const Header = (props) => {
    return react_1.default.createElement("header", { key: "SampoHeader", className: `d-block d-md-none w-100 position-absolute ${props.isOpen ? 'mobile-nav-open' : ''}` },
        react_1.default.createElement("div", { className: 'row g-0 align-items-center px-8 position-fixed w-100 py-8' },
            react_1.default.createElement("div", { className: 'col-auto', style: { width: '2rem' } },
                react_1.default.createElement("button", { className: 'icon-menu_icon p-0', onClick: () => props.openNav(), "aria-pressed": props.isOpen || false },
                    react_1.default.createElement("span", { className: 'visually-hidden' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.labels, field: 'openMenu' })))),
            react_1.default.createElement("div", { className: 'col text-center' },
                react_1.default.createElement("a", { href: props === null || props === void 0 ? void 0 : props.homehref, target: '_self', className: 'logo d-block' },
                    react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: props.siteLogo, expandedValue: props.siteLogo.expanded }),
                    react_1.default.createElement("span", { className: 'visually-hidden' },
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.settings, field: 'logoAccessibilityHint' })))),
            react_1.default.createElement("div", { className: 'col-auto d-flex justify-content-end', style: { width: '2rem' } },
                react_1.default.createElement(NavigationSearch_1.default, { labels: props.labels, inHeader: true }))));
};
exports.Header = Header;
exports.default = exports.Header;
